<div class="panel panel-default">
    <div class="panel-body bodyDescription">
        <div class="infoTitleList">{{richText.title}}</div>
        <div>
            <ul class="descListHeader" *ngFor="let line of listText">
                <li class="listDescription">{{line.text}}</li>
            </ul>
        </div>
    </div>
</div>